import { useMutation } from '@tanstack/react-query';
import { IAssetPurchaseOrder, IClientInstallation } from '@api/models';
import { removeFileClientInstallation, updateFileClientInstallation } from '@api/services/client-installation.service';
import { removeFilePurchaseOrder, updateFilePurchaseOrder } from '@api/services/asset-purchaase-order.service';

export const useFileUploadAssetPurchaseOrder = (
    clientInstallationId: string,
    projectInstallationId: string,
    initialData: IAssetPurchaseOrder,
    setData: (data: any) => void
) => {
    const addFileMutation = useMutation({
        mutationFn: (payload: any) =>
            updateFilePurchaseOrder(clientInstallationId, projectInstallationId, initialData._id, payload),
        onSuccess: (updatedInstallation) => {
            // setData((prev: IClientInstallation) => ({
            //     ...prev,
            //     files: [...(prev.files || []), ...newFiles],
            //   }));
            setData(updatedInstallation);
        },
    });

    const removeFileMutation = useMutation({
        mutationFn: (fileId: string) =>
            removeFilePurchaseOrder(clientInstallationId, projectInstallationId, initialData._id, fileId),
        onSuccess: (updatedInstallation) => {
            // setData(updatedInstallation);
        },
    });

    const handleAddFiles = (files: FileList | null) => {
        if (!files) return;

        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append('file', file);
        });

        addFileMutation.mutate(formData);
    };

    const handleRemoveFile = (fileId: string) => {
        removeFileMutation.mutate(fileId);
        setData((prev: IAssetPurchaseOrder) => {
            const updatedFiles = prev.files?.filter((file: any) => file._id !== fileId) || [];
            return { ...prev, files: updatedFiles };
        });
    };

    return {
        handleAddFiles,
        handleRemoveFile,
        isUploading: addFileMutation.isLoading,
        isRemoving: removeFileMutation.isLoading,
    };
};
